import React, { ReactNode } from 'react';
import { Layout } from '@bit/bit.rendering.constants.layouts';
import { isMobile } from 'is-mobile';

import { DesktopTemplate } from './homepage-desktop';
import { MobileTemplate } from './homepage-mobile';

export type LayoutState = {
	showFileExplorer: boolean;
	terminalDrawer: boolean;
};

export type LayoutProps = {
	layout: Layout;

	fileExplorer: ReactNode;
	editor: ReactNode;
	player: ReactNode;
	terminal: ReactNode;
	controlBoard: ReactNode;
};

export function HomepageTemplate(props: LayoutProps) {
	if (isMobile()) {
		return <MobileTemplate {...props} />;
	}

	return <DesktopTemplate {...props} />;
}
